// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import FastClick from 'fastclick'
import 'lib-flexible/flexible.js'
import vueWechatTitle from "vue-wechat-title"
import Vant from 'vant'
import 'vant/lib/index.css'
import vView from 'vue-view-lazy'
import store from './store/index'
// 在入口文件中（main.js），导入组件库
import vueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'

//引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入饼状图
require('echarts/lib/chart/pie');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title'); //图例翻译滚动

Vue.prototype.$echarts = echarts
import {
  UrlSearch
} from './apis/InterceptUrl'
const device = navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?) like mac os/)
if (!device || parseInt(device[1]) < 11) {
  FastClick.attach(document.body)
}
let Request = new UrlSearch()
Vue.prototype.$urlSearch = Request;
/* eslint-disable no-new */
Vue.use(vueWechatTitle)
// 注册组件库
Vue.use(vueHashCalendar)
Vue.use(Vant)
Vue.use(Vuex)
Vue.use(vView)
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  store,
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js